import React, { useState } from "react";
import { BoundingBox, FileText } from "@phosphor-icons/react";
import { Flows } from "../../../../util/Types/Folder";
import { isFluxbotFlow, isFormFlow } from "../utils";
import { useAgentsSidebarContext } from "./context";
import { Item } from "./Item";
import { ActionMenu } from "./ActionMenu";

interface AgentItemProps {
  flow: Flows;
  folderId: string;
  flowFolderName?: string;
  onRename?: (flow: Flows, folderId: string) => void;
  onDelete?: (flow: Flows) => void;
  onShare?: (flow: Flows, folderId: string) => void;
  onOpenInNewTab?: (flow: Flows) => void;
  onCreateInterface?: (flow: Flows, folderId: string) => void;
  onAddToLibrary?: (flow: Flows, folderId: string) => void;
  onDuplicate?: (flow: Flows, folderId: string) => void;
}

export const AgentItem: React.FC<AgentItemProps> = ({
  flow,
  folderId,
  flowFolderName,
  onRename,
  onDelete,
  onShare,
  onOpenInNewTab,
  onCreateInterface,
  onAddToLibrary,
  onDuplicate,
}) => {
  const { activeFlowId, onFlowClick } = useAgentsSidebarContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isForm = isFormFlow(flow);
  const isFluxbot = isFluxbotFlow(flow, flowFolderName);

  const handleMenuClick = (anchor: HTMLElement) => {
    setAnchorEl(anchor);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Item
        icon={isForm ? <FileText size={16} /> : <BoundingBox size={16} />}
        label={flow.name}
        isActive={activeFlowId === flow.id}
        isNested
        onClick={() => onFlowClick(flow, folderId)}
        onMenuClick={handleMenuClick}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onRename={onRename ? () => onRename(flow, folderId) : undefined}
        onShare={onShare ? () => onShare(flow, folderId) : undefined}
        onOpenInNewTab={onOpenInNewTab ? () => onOpenInNewTab(flow) : undefined}
        onCreateInterface={
          !isForm && !isFluxbot && onCreateInterface
            ? () => onCreateInterface(flow, folderId)
            : undefined
        }
        onAddToLibrary={
          !isForm && !isFluxbot && onAddToLibrary
            ? () => onAddToLibrary(flow, folderId)
            : undefined
        }
        libraryLabel={flow.library ? "Edit Library" : "Add to Library"}
        onDuplicate={
          !isForm && onDuplicate ? () => onDuplicate(flow, folderId) : undefined
        }
        onDelete={onDelete ? () => onDelete(flow) : undefined}
      />
    </>
  );
};
